import { render, staticRenderFns } from "./EditAddonModal.vue?vue&type=template&id=6c898b0c&"
import script from "./EditAddonModal.vue?vue&type=script&lang=js&"
export * from "./EditAddonModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports